<div id="linkAliasCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@link_alias_dialog_details">Associa operatore</ng-container>
  </div>

  <div class="control-card-content">

    <mat-tab-group [animationDuration]="'0ms'">

      <mat-tab label={{linkExistingOwnerString}}>
        <div id="linkExistingOwner">
          <p id="aliasDescription" i18n="@@link_alias_dialog_description">
            Inserire l'indirizzo email associato all'utente che si desidera associare come operatore
          </p>


          <form [formGroup]="linkAliasForm">
            <table class="simple-table">
              <tr>
                <!-- width="125px"  -->
                <td class="text-dark" i18n="@@link_alias_dialog_alias_email">Email operatore :</td>
                <td><input id="name-input" formControlName="email" type="text" /></td>
              </tr>
            </table>
          </form>

          <div class="control-card-buttons" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start">
            <div fxFlex="25" [fxFlex.lt-md]="0">
              <a (click)="linkAliasToOwner()" class="button">
                <ng-container i18n="@@link_alias_dialog_link">Associa</ng-container>
                <span>
                  <fa-icon icon="link"></fa-icon>
                </span>
              </a>
            </div>
            <div fxFlex="50" [fxFlex.lt-md]="0">
            </div>
            <div fxFlex="25" [fxFlex.lt-md]="0">
              <a (click)="closeDialog()" class="button button-red" id="cancelButton">
                <ng-container i18n="@@link_alias_dialog_cancel">Annulla</ng-container>
                <span>
                  <fa-icon icon="times"></fa-icon>
                </span>
              </a>
            </div>
          </div>


          <div id="errorsSpacerDiv" *ngIf="!invalidEmail && !aliasNotFoundError" fxLayout="row" fxLayoutAlign="center start">
          </div>


          <div id="errorsDiv" *ngIf="invalidEmail || aliasNotFoundError" fxLayout="row" fxLayoutAlign="center center">
            <div fxFlex="100">
              <p class="text-small text-error" *ngIf="invalidEmail" i18n="@@link_alias_dialog_invalid_code">
                L'indirizzo email inserito non é valido</p>

              <p class="text-small text-error" *ngIf="aliasNotFoundError" i18n="@@link_alias_dialog_email_not_found">
                Nessun utente associato all'indirizzo inserito</p>
            </div>
          </div>


          <app-loading-screen #linkAliasLoader [loading]="false"></app-loading-screen>

        </div>
      </mat-tab>

      <mat-tab label={{createAliasString}}>
        <div id="createAlias">
          <p id="aliasDescription" i18n="@@link_alias_dialog_description_new_user">
            Inserire i dati relativi all'operatore che desideri creare
          </p>


          <form [formGroup]="newAliasForm">
            <table class="simple-table">
              <tr>
                <!-- width="125px"  -->
                <td class="text-dark" i18n="@@link_alias_dialog_new_user_alias_email">Email :</td>
                <td><input id="name-input" formControlName="email" type="text" /></td>
              </tr>
              <tr>
                <td class="text-dark" i18n="@@link_alias_dialog_new_user_password">Password</td>
                <td><input id="password-input" formControlName="password" type="password"></td>
              </tr>
              <tr>
                <td class="text-dark" i18n="@@link_alias_dialog_new_user_password_again">Ripeti password</td>
                <td><input id="password2-input" formControlName="password2" type="password"></td>
              </tr>
            </table>
          </form>

          <div class="control-card-buttons" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start">
            <div fxFlex="30" [fxFlex.lt-md]="0">
              <a (click)="createAliasUser()" class="button">
                <ng-container i18n="@@link_alias_dialog_create_user">Crea utente</ng-container>
                <span>
                  <fa-icon icon="plus"></fa-icon>
                </span>
              </a>
            </div>
            <div fxFlex="45" [fxFlex.lt-md]="0">
            </div>
            <div fxFlex="25" [fxFlex.lt-md]="0">
              <a (click)="closeDialog()" class="button button-red" id="cancelButton">
                <ng-container i18n="@@link_alias_dialog_cancel">Annulla</ng-container>
                <span>
                  <fa-icon icon="times"></fa-icon>
                </span>
              </a>
            </div>
          </div>


          <div id="errorsSpacerDiv" *ngIf="!invalidEmail && !aliasNotFoundError" fxLayout="row" fxLayoutAlign="center start">
          </div>


          <div id="errorsDiv" *ngIf="newUserinvalidEmail || newUserInvalidPassword || newUserasswordsNotMatchError|| userAlreadyExists" fxLayout="row" fxLayoutAlign="center center">
            <div fxFlex="100">
              <p class="text-small text-error" *ngIf="newUserinvalidEmail" i18n="@@link_alias_dialog_new_user_invalid_code">
                L'indirizzo email inserito non é valido</p>
              <p class="text-small text-error" *ngIf="newUserInvalidPassword" i18n="@@link_alias_dialog_new_user_invalid_length">
                Devi inserire una password valida (almeno 8 caratteri)
              </p>
              <p class="text-small text-error" *ngIf="newUserasswordsNotMatchError" i18n="@@link_alias_dialog_new_user_passwords_dont_match">
                Le password inserite non coincidono
              </p>
              <p class="text-small text-error" *ngIf="userAlreadyExists" i18n="@@link_alias_dialog_new_user_already_exists">
                L'indirizzo email appartiene ad un utente esistente
              </p>
            </div>
          </div>


          <app-loading-screen #createAliasLoader [loading]="false"></app-loading-screen>
        </div>
      </mat-tab>

    </mat-tab-group>

  </div>
</div>